"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Calendar from foundation/Calendar
 * @trackcomponent
 */
export const Calendar = createSVGIcon(
  <>
    <path
      d="M28.51 30.4999H1.5C0.95 30.4999 0.5 30.0499 0.5 29.4999V4.3999C0.5 3.8499 0.95 3.3999 1.5 3.3999H28.51C29.06 3.3999 29.51 3.8499 29.51 4.3999V29.4999C29.51 30.0499 29.06 30.4999 28.51 30.4999Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M0.789993 9.54004H29.22"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M23.71 0.5V5.72M6.3 0.5V5.72V0.5Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M9.59 13.97H5.14V18.42H9.59V13.97Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M17.23 13.97H12.78V18.42H17.23V13.97Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M24.87 13.97H20.42V18.42H24.87V13.97Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </>,
  "Calendar",
  { viewBox: "0 0 33 31", titleAccess: "Calendar" }
);
